import {
  CANONICAL_COLORS_EN,
  COLOR_MAP,
  COLOR_ALIASES_TO_EN,
  COLOR_DISPLAY_LABELS
} from '../constants/colorConstants';

export const normalizeColorToCanonical = (color) => {
  if (!color) return '';

  const normalizedInput = String(color).trim().toUpperCase();
  return COLOR_ALIASES_TO_EN[normalizedInput] || normalizedInput;
};

export const isCanonicalColor = (color) => CANONICAL_COLORS_EN.includes(String(color || '').trim().toUpperCase());

export const formatColorForDisplay = (colorName, language = 'it') => {
  const canonical = normalizeColorToCanonical(colorName);
  const lang = COLOR_DISPLAY_LABELS[language] ? language : 'it';

  if (!canonical) return '';
  return String(COLOR_DISPLAY_LABELS[lang][canonical] || canonical).toUpperCase();
};

export const getColorsForLanguage = () => [...CANONICAL_COLORS_EN];

export const getColorOptionsForLanguage = (language = 'it') => {
  const lang = COLOR_DISPLAY_LABELS[language] ? language : 'it';
  return CANONICAL_COLORS_EN.map((value) => ({
    value,
    label: COLOR_DISPLAY_LABELS[lang][value] || value
  }));
};

export const translateColorForDisplay = (color, targetLanguage = 'it') => {
  const canonical = normalizeColorToCanonical(color);
  const lang = COLOR_DISPLAY_LABELS[targetLanguage] ? targetLanguage : 'it';
  if (!canonical) return canonical;
  return String(COLOR_DISPLAY_LABELS[lang][canonical] || canonical).toUpperCase();
};

export const getColorSwatchSegments = (color) => {
  const canonical = normalizeColorToCanonical(color);

  if (canonical === 'YE/GN') {
    return [
      COLOR_MAP.YELLOW || '#FFD600',
      COLOR_MAP.GREEN || '#4CAF50'
    ];
  }

  return [COLOR_MAP[canonical] || '#808080'];
};

export const lightenHexColor = (hexColor, amount = 0.43) => {
  const normalized = String(hexColor || '').replace('#', '');
  if (!/^[0-9a-f]{6}$/i.test(normalized)) return '#939195';

  const channels = [0, 2, 4].map((offset) => Number.parseInt(normalized.slice(offset, offset + 2), 16));
  const lightened = channels.map((channel) => Math.round(channel + ((255 - channel) * amount)));
  return `#${lightened.map((channel) => channel.toString(16).padStart(2, '0')).join('')}`;
};
